import { Routes, RouterModule, PreloadAllModules, RouterState  } from '@angular/router';
import { ModuleWithProviders }          from '@angular/core';

import { environment }          from './../environments/environment';

/* Panel */
import { PrincipalComponent }           from './maqueta/panel/componentes/principal/principal.component';
import { NotFoundComponent }            from './maqueta/panel/componentes/errors/not-found/not-found.component';
import { EnConstruccionComponent }      from './maqueta/panel/componentes/errors/en-construccion/en-construccion.component';
import { UsuarioNoAutorizadoComponent } from './maqueta/panel/componentes/usuario-no-autorizado/usuario-no-autorizado.page';
import { childrenPublicAdmin }          from './app.routing.public';

//import { PanelWebPage } from './maqueta/panelWeb/panel-web-page/panel-web.page';

/* Guards */
import { CanActivateViaAuthGuard } from '@maq-autorizacion/guards/can-activate-via-auth-guard';
import { CanActivateViaNoAuthGuard } from '@maq-autorizacion/guards/can-activate-via-no-auth-guard';
import { CanActivateChildViaAuthGuard } from '@maq-autorizacion/guards/can-activate-child-via-auth-guard';
import { CanActivateChildViaNoAuthGuard } from '@maq-autorizacion/guards/can-activate-child-via-no-auth-guard';


export const routes: Routes = [
  {
    path: '', component: PrincipalComponent,
    
    children:[       
        { path: '', redirectTo: 'usuarios', pathMatch: 'full'},      
        
        /* Modulos de del proyecto */
        { path: 'rutas'                   ,loadChildren: () => import('@proyecto/pk-rutas/pk-rutas.module').then(m => m.PkRutasModule), data: { breadcrumb: 'breadcrumb.rutas' },  canActivate: [CanActivateViaAuthGuard]  },        
        { path: 'organizacion'            ,loadChildren: () => import('@maq-modules/organizaciones/organizaciones.module').then(m => m.OrganizacionesModule), data: { breadcrumb: 'menu.organizaciones' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'conectorRoadNet'         ,loadChildren: () => import('@proyecto/soap/soap.module').then(m => m.SoapModule), data: { breadcrumb: 'soap.conectoresRoadNet' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'importar'                ,loadChildren: () => import('@proyecto/mapeador-archivos/mapeador-archivos.module').then(m => m.ImportarModule), data: { breadcrumb: 'soap.importar' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'reportes'                ,loadChildren: () => import('@proyecto/reportes/reportes.module').then(m => m.ReportesModule), data: { breadcrumb: 'breadcrumb.rutas' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'tableroControl'          ,loadChildren: () => import('@proyecto/tableroControl/tablero-control.module').then(m => m.TableroControlModule), data: { breadcrumb: 'breadcrumb.tableroControl' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'geocode'                 ,loadChildren: () => import('@proyecto/geocode/geocode.module').then(m => m.GeocodeModule), data: { breadcrumb: 'geocode.geocodificacion' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'eventos'                 ,loadChildren: () => import('@proyecto/eventos/eventos.module').then(m => m.EventosModule), data: { breadcrumb: 'eventos' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'encuestas'               ,loadChildren: () => import('@proyecto/encuestas/encuestas.module').then(m => m.EncuestasModule), data: { breadcrumb: 'encuestas' },  canActivate: [CanActivateViaAuthGuard]  },                
        { path: 'log-apis'                ,loadChildren: () => import('@proyecto/log-apis/log-apis.module').then(m => m.LogApisModule), data: { breadcrumb: 'moduloLogApis.logLehmann' },  canActivate: [CanActivateViaAuthGuard]  },                
    ]
  },
  
  //Hace: cambiar login por autorización y mover a este modulo, usuarioNoAutorizado
  { path: 'login', loadChildren: () => import('@maq-autorizacion/autorizacion.module').then(m => m.AutorizacionModule) } ,
  { path: '**', component: NotFoundComponent }
  
];



export const concatPublic = function(routes) {
  if (!environment.enConstruccion){
    routes[0].children = routes[0].children.concat(childrenPublicAdmin)
    //console.log("newRoutes",routes);
    return routes;
    
  } else {
      return [{ path: '**', component: EnConstruccionComponent } ];
  }
};

export const routing: ModuleWithProviders<any> = RouterModule.forRoot( concatPublic(routes), {
    relativeLinkResolution: 'legacy'
});

